/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listCustomerManagementEventsParamsCustomerIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const listCustomerManagementEventsParamsCursorMax = 512;

export const listCustomerManagementEventsParamsCursorRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const listCustomerManagementEventsParamsLimitDefault = 50;
export const listCustomerManagementEventsParamsLimitMax = 100;

export const ListCustomerManagementEventsParams = zod.object({
  customerId: zod.uuid().regex(listCustomerManagementEventsParamsCustomerIdRegExp).optional(),
  outcome: zod.enum(['success', 'refused', 'unavailable']).optional(),
  action: zod
    .enum([
      'customers.customer-created',
      'customers.customer-renamed',
      'customers.customer-archived',
      'customers.customer-reactivated',
      'customers.customer-deleted',
      'customers.assignment-added',
      'customers.assignment-removed',
      'customers.phone-number-added',
      'customers.phone-number-changed',
      'customers.phone-number-removed',
      'customers.customer-change-refused',
      'customers.assignment-change-refused',
      'customers.phone-number-change-refused',
      'customers.dependency-unavailable',
    ])
    .optional(),
  cursor: zod
    .string()
    .min(1)
    .max(listCustomerManagementEventsParamsCursorMax)
    .regex(listCustomerManagementEventsParamsCursorRegExp)
    .optional(),
  limit: zod
    .int()
    .min(1)
    .max(listCustomerManagementEventsParamsLimitMax)
    .default(listCustomerManagementEventsParamsLimitDefault),
});

export type ListCustomerManagementEventsParams = zod.input<
  typeof ListCustomerManagementEventsParams
>;
export type ListCustomerManagementEventsParamsOutput = zod.output<
  typeof ListCustomerManagementEventsParams
>;
